import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './containers/Home';
import Error from './containers/Error';
import NotFound from './containers/NotFound';
import AppliedRoute from './components/AppliedRoute';

import ViewProdReport from './containers/ViewProdReport';
import UploadParsV2 from './containers/UploadParsV2';
import UploadForecast from './containers/UploadForecast';

import ViewForecast from './containers/ViewForecast';

import ViewEmptyChannels from './containers/ViewEmptyChannels';
import ViewStockOuts from './containers/ViewStockOuts';
import ViewStockingLogs from './containers/ViewStockingLogs';
import ViewRouteTemperatures from './containers/ViewRouteTemperatures';
import SingularLocationParsV2 from './containers/SingularLocationParsV2';

import ViewPermissions from './containers/ViewPermissions';

import LocationsWrapperGraphQL from './containers/LocationsWrapperGraphQL';
import CustomerGroup from './containers/CustomerGroup';

import PortfolioHealth from './containers/PortfolioHealth';
import AcceptDelivery from './containers/NorthEastDelivery';
import Coupons from './containers/Coupons/Coupons';
import ViewDropOffSummary from './containers/ViewDropOffSummary';
import ViewNextmv from './containers/Nextmv/ViewNextmv';
import ViewJitManagement from './containers/ViewJitManagement';
import SupervisorDashboard from './containers/SupervisorDashboard/SupervisorDashboard';
import ViewStockingDashboard from './containers/ViewStockingDashboard';
import Planograms from './containers/Planograms';
import ItemPricesCSVTool from './containers/ItemPrices/ItemPricesCSVTool';
import SchemaTemplatesCSVTool from './containers/SchemaTemplates/SchemaTemplatesCSVTool';
import ItemPricesLanding from './containers/ItemPrices/ItemPricesLanding';
import SchemaConditionsLanding from './containers/SchemaConditions/SchemaConditionsLanding';
import SleepScreensLanding from './containers/SleepScreens/SleepScreensLanding';
import SleepScreenDetail from './containers/SleepScreens/SleepScreenDetail';
import SleepScreenEdit from './containers/SleepScreens/SleepScreenEdit';
import DriverFixesList from './containers/DriverFixesList';

export default ({ childProps }) => (
  <Switch>
    <AppliedRoute path="/home" exact component={Home} props={childProps} />
    <AppliedRoute
      path="/portfoliohealth"
      exact
      component={PortfolioHealth}
      props={childProps}
    />
    <AppliedRoute
      path="/delivery"
      exact
      component={AcceptDelivery}
      props={childProps}
    />
    <AppliedRoute
      path="/locations/*"
      exact
      component={LocationsWrapperGraphQL}
      props={childProps}
    />
    <AppliedRoute
      path="/forecast/view"
      exact
      component={ViewForecast}
      props={childProps}
    />
    <AppliedRoute
      path="/forecast/upload"
      exact
      component={UploadForecast}
      props={childProps}
    />
    <AppliedRoute
      path="/pars/list"
      exact
      component={SingularLocationParsV2}
      props={childProps}
    />
    <AppliedRoute
      path="/pars/upload"
      exact
      component={UploadParsV2}
      props={childProps}
    />
    <AppliedRoute
      path="/pars/prodreport"
      exact
      component={ViewProdReport}
      props={childProps}
    />
    <AppliedRoute
      path="/pars/*"
      exact
      component={SingularLocationParsV2}
      props={childProps}
    />

    <AppliedRoute
      path="/customers/group"
      exact
      component={CustomerGroup}
      props={childProps}
    />

    <AppliedRoute
      path="/reports/checkpoints"
      exact
      component={ViewStockingDashboard}
      props={childProps}
    />
    <AppliedRoute
      path="/reports/emptychannels"
      exact
      component={ViewEmptyChannels}
      props={childProps}
    />

    <AppliedRoute
      path="/reports/stockinglogs"
      exact
      component={ViewStockingLogs}
      props={childProps}
    />
    <AppliedRoute
      path="/reports/routetemperatures"
      exact
      component={ViewRouteTemperatures}
      props={childProps}
    />
    <AppliedRoute
      path="/reports/dropoffsummary"
      exact
      component={ViewDropOffSummary}
      props={childProps}
    />
    <AppliedRoute
      path="/reports/stockouts"
      exact
      component={ViewStockOuts}
      props={childProps}
    />
    <AppliedRoute
      path="/driver-fixes"
      exact
      component={
        childProps.hasAccessToDriverFixCMS ? DriverFixesList : NotFound
      }
      props={childProps}
    />
    <AppliedRoute
      path="/users/permissions"
      exact
      component={ViewPermissions}
      props={childProps}
    />
    <AppliedRoute
      path="/checkpoints"
      exact
      component={ViewStockingDashboard}
      props={childProps}
    />
    <AppliedRoute
      path="/nextmv"
      exact
      component={ViewNextmv}
      props={childProps}
    />
    <AppliedRoute
      path="/jit-management"
      exact
      component={ViewJitManagement}
      props={childProps}
    />
    <AppliedRoute
      path="/supervisor-dashboard"
      exact
      component={SupervisorDashboard}
      props={childProps}
    />
    <AppliedRoute path="/Error" exact component={Error} props={childProps} />
    <AppliedRoute path="/" exact component={Home} props={childProps} />

    <AppliedRoute
      path="/coupons"
      exact
      component={Coupons}
      props={childProps}
    />

    <AppliedRoute
      path="/planograms"
      exact
      component={Planograms}
      props={childProps}
    />

    <AppliedRoute
      path="/base-price-management"
      exact
      component={ItemPricesCSVTool}
      props={childProps}
    />

    <AppliedRoute
      path="/base-price-landing"
      exact
      component={ItemPricesLanding}
      props={childProps}
    />

    <AppliedRoute
      path="/fridge-schemas/upload"
      exact
      component={SchemaTemplatesCSVTool}
      props={childProps}
    />

    <AppliedRoute
      path="/schema-conditions"
      exact
      component={SchemaConditionsLanding}
      props={childProps}
    />

    <AppliedRoute
      path="/sleep-screens"
      exact
      component={SleepScreensLanding}
      props={childProps}
    />

    <AppliedRoute
      path="/sleep-screens/:sleepScreenId/edit"
      exact
      component={SleepScreenEdit}
      props={childProps}
    />

    <AppliedRoute
      path="/sleep-screens/:sleepScreenId"
      exact
      component={SleepScreenDetail}
      props={childProps}
    />

    {/* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </Switch>
);
